import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-0"}],["path",{"d":"M9 8h.01","key":"svg-1"}],["path",{"d":"M15 8h.01","key":"svg-2"}],["path",{"d":"M11 12h2","key":"svg-3"}]]

const IconMoodLookUp = createReactComponent('outline', 'mood-look-up', 'MoodLookUp', __iconNode);

export default IconMoodLookUp;